<template>
  <div id="app">
    <template v-if="isLoginPage">
      <router-view></router-view>
    </template>
    <template v-else>
      <div class="app-layout">
        <Sidebar />
        <div class="main-content ml200">
          <Header />
          <div class="page-content">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Sidebar from './components/Sidebar.vue'
import Header from './components/Header.vue'

export default {
  name: 'App',
  components: {
    Sidebar,
    Header
  },
  computed: {
    isLoginPage () {
      return this.$route.path === '/login'
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  color: #333;
  background-color: #f5f7fa;
}

#app {
  min-height: 100vh;
}

.app-layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.ml200 {
  margin-left: 200px;
}
.page-content {
  flex: 1;
  padding:60px 20px 20px 20px;
  background-color: #f5f7fa;
}
</style>
